import Alpine from 'alpinejs';

require('bootstrap-sass');

require('./polyfill');
require('./datatables');
require('./form');
require('./prerequisites');
require('./filter');
require('./toggle'); 
require('./confirmation');
require('./print');

require('./font-awesome');

window.Alpine = Alpine;

Alpine.start();
